module.exports = __webpack_public_path__ + "85a53cc60edf4cfd10afa99eff65af9a.pdf";